export default function actions() {
	return {
		fetchInsuranceEvents: async ({ commit }) => {
			const response = await window.axios.get('/api/calculator/insurance-events');

			commit('setInsuranceEvents', response.data);
		},
		fetchPremiseTypes: async ({ commit }) => {
			const response = await window.axios.get('/api/calculator/premise-types');

			commit('setPremiseTypes', response.data);
		},
		fetchMovableTypes: async ({ commit }) => {
			const response = await window.axios.get('/api/calculator/movable-types');

			commit('setMovableTypes', response.data);
			commit('createMovablesByTypes');
		},
		fetchOutbuildingTypes: async ({ commit }) => {
			const response = await window.axios.get('/api/calculator/outbuilding/types');

			commit('setOutbuildingTypes', response.data);
		},
		fetchOutbuildingLocations: async ({ commit }) => {
			const response = await window.axios.get('/api/calculator/outbuilding/locations');

			commit('setOutbuildingLocations', response.data);
		},
		searchAddress: async ({ commit }, payload) => {
			const response = await window.axios.post('/api/calculator/address/search', payload);
			commit('setSearchResult', { type: payload.type, data: response.data, group: payload.group });
		},
		saveCalculationData: async ({ commit, getters }) => {
			const user_id = getters['auth/isConsultant']
				? getters['getSelectedUser']
				: getters['auth/getCurrentUser'] !== null
				? getters['auth/getCurrentUser'].id
				: null;

			const responseRealEstate = await window.axios.post('/api/calculator/real-estate', {
				...getters['getDataByGroup']('real_estate'),
				user_id,
				premises: getters['getDataByGroup']('premises'),
				outbuildings: getters['getDataByGroup']('outbuildings'),
				buildings: getters['getDataByGroup']('buildings'),
				movables: getters['getDataByGroup']('movables'),
				valuables: getters['getDataByGroup']('valuables'),
			});

			if (responseRealEstate.data.success) {
				commit('setRealEstateData', responseRealEstate.data.real_estate);

                    const questionAnswersData = getters.getQuestionAnswers.isNewContract ?
                        {
                            is_mfo: null,
                            old_start_of_risk: null,
                            old_insurer: null,
                            old_bond_number: null,
                            two_year: null,
                        } : {
                            is_mfo: getters.getQuestionAnswers.isMfo,
                            old_start_of_risk: getters.getQuestionAnswers.startOfRisk,
                            old_insurer: getters.getQuestionAnswers.insurer,
                            old_bond_number: getters.getQuestionAnswers.bondNumber,
                            two_year: getters.getQuestionAnswers.twoYear,
                        };

				const responseCalculation = await window.axios.post('/api/calculator/calculation', {
					...getters['getDataByGroup']('calculation'),
					insurance_events: getters['getSelectedInsuranceEvents'](),
					user_id,
					consultant_id: getters['auth/isConsultant'] ? getters['auth/getCurrentUser'].id : null,
					real_estate_id: responseRealEstate.data.real_estate.id,
                    is_new_contract: getters.getQuestionAnswers.isNewContract,
                    ...questionAnswersData,
					category: getters['getCategory'],
					on_my_own: getters.getStateData('onMyOwn'),
                    is_business_process: getters.getIsBusinessProcess,
                    is_campaign_calculation: getters.getIsCampaignCalculation,
                    has_condominium_insurance: (getters['getRealEstate']['type'] === 0) ? getters.getQuestionAnswers.hasCondominiumInsurance : false,
                    condominium_insurer: getters.getQuestionAnswers.condominiumInsurer,
				});

				if (responseCalculation.data.success) {
					commit('setCalculationData', responseCalculation.data.calculation);
				}
			}
		},
		calculate: async ({ commit, getters }) => {
			if (getters.getPopup === 'StartOfRiskChanger') {
				commit('showPopup', null);
			}

			commit('setLoading', true);
			const response = await window.axios.get(`/api/calculator/calculate/${getters['getCalculation'].hash}`);

			if (response.data.success) {
				commit('setLoading', false);
				commit('setOffers', response.data.results);

				let errors = [];

				response.data.results.forEach(result => {
					if (!result.success) {
						result.errors.forEach(error => {
							errors.push(`${result.insurer_name} - ${error.hibaKod}: ${error.hibaUzenet}`);
						});
					}
				});

				commit('setWsErrors', errors);
			} else {
				commit('setLoading', false);

				let errors = [];

				response.data.errors.forEach(error => {
					errors.push(`WS - ${error.hibaKod}: ${error.hibaUzenet}`);
				});

				commit('setWsErrors', errors);
				return response.data.errors;
			}
		},
		recalculate: async ({ commit, getters }) => {
			commit('setLoading', true);
			commit('setError', false);
			commit('clearOffers');
			const response = await window.axios.post(`/api/calculator/recalculate/${getters['getCalculation'].hash}`, {
				real_estate: getters['getDataByGroup']('real_estate'),
				buildings: getters['getDataByGroup']('buildings'),
				outbuildings: getters['getDataByGroup']('outbuildings'),
				movables: getters['getDataByGroup']('movables'),
				valuables: getters['getDataByGroup']('valuables'),
				calculation: getters['getDataByGroup']('calculation'),
				insurance_events: getters['getSelectedInsuranceEvents'](),
			});

			if (response.data.success) {
				commit('setOffers', response.data.results);
				commit('setLoading', false);
			} else {
				commit('setLoading', false);
				return response.data.errors;
			}
		},
		fetchCalculation: async ({ commit, dispatch, state }, hash) => {
			const response = await window.axios.get(`/api/calculator/calculation/hash/${hash}`);

			if (response.data.success) {
				commit('setCalculationData', response.data.calculation);
				commit('setCategory', response.data.calculation.category);
				commit('setRealEstateData', response.data.calculation.real_estate);
				commit('setOutbuildings', response.data.calculation.real_estate.outbuildings);
				commit('setBuildings', response.data.calculation.real_estate.buildings);
				commit('setPremises', response.data.calculation.real_estate.premises);
				commit('setMovables', response.data.calculation.real_estate.movables);
				commit('setValuables', response.data.calculation.real_estate.valuables);
				commit('setSelectedUser', response.data.calculation.real_estate.user_id);
                commit('setIsBusinessProcess',response.data.calculation.is_business_process);

				commit('setQuestionAnswers', {
						isNewContract: response.data.calculation.is_new_contract,
                        hasCondominiumInsurance: response.data.calculation.has_condominium_insurance,
                        condominiumInsurer: response.data.calculation.condominium_insurer,
						isMfo: response.data.calculation.is_mfo,
						startOfRisk: response.data.calculation.old_start_of_risk,
						insurer: response.data.calculation.old_insurer,
						twoYear: response.data.calculation.two_year,
                        bondNumber: response.data.calculation.old_bond_number,
				});

                if(response.data.calculation.is_campaign_calculation) {
                    // not pretty but can't really fix it properly because it is in live.
                    commit('setIsCampaignCalculation', true);
                }

				response.data.calculation.insurance_events.forEach(event => {
					commit('setEvent', { id: event.id });
					commit('setEvent', { id: event.id, temp: true });
				});
			}
		},
		fetchRealEstates: async ({ commit, getters }) => {
			const response = await window.axios.get(`/api/calculator/real-estate/${getters['auth/getCurrentUser'].id}`);

			if (response.data.success) {
				commit('setRealEstates', response.data.real_estates);
			}
		},
		registerCalculate: async ({ commit, getters }, user) => {
			const response = await window.axios.post('/vue/register-calculate', {
				user,
				realEstate: {
					...getters['getDataByGroup']('real_estate'),
					premises: getters['getDataByGroup']('premises'),
					buildings: getters['getDataByGroup']('buildings'),
					outbuildings: getters['getDataByGroup']('outbuildings'),
					movables: getters['getDataByGroup']('movables'),
					valuables: getters['getDataByGroup']('valuables'),
				},
				calculation: {
					...getters['getDataByGroup']('calculation'),
					insurance_events: getters['getSelectedInsuranceEvents'](),
					category: getters['getCategory'],
				},
			});

			if (response.data.success) {
				commit('auth/setCurrentUser', response.data.user);
				commit('setRealEstateData', response.data.real_estate);
				commit('setCalculationData', response.data.calculation);
			}

			return response.data;
		},
		setSelectedRealEstateData: ({ commit, getters }, id) => {
			const selected = getters.getRealEstates.find(realEstate => realEstate.id === id);

			if (selected.house_number === null) {
				commit('setStateData', { prop: 'hasParcelNumber', value: true });
			}

            delete selected.id;
            selected.outbuildings.forEach(obj => delete obj.id);
            selected.buildings.forEach(obj => delete obj.id);
            selected.premises.forEach(obj => delete obj.id);
            selected.movables.forEach(obj => delete obj.id);
            selected.valuables.forEach(obj => delete obj.id);

            if(getters["getCategory"] === 2) {
                delete selected.movable_value;
                delete selected.valuable_value;
                selected.outbuildings.forEach(obj => delete obj.movable_value);
                selected.buildings = [];
                selected.movables = [];
                selected.valuables = [];
            }

            commit('setRealEstateData', selected);
            commit('setOutbuildings', selected.outbuildings);
            commit('setBuildings', selected.buildings);
            commit('setPremises', selected.premises);
            commit('setMovables', selected.movables);
            commit('setValuables', selected.valuables);
		},
		clearSelectedRealEstateData: ({ commit, getters }) => {
			commit('setRealEstateData', {
				id: null,
				user_id: null,
				postal_code: null,
				city: null,
				address: null,
				house_number: null,
				type: null,
				ownership: null,
				floor_area: null,
				insurance_value: null,
				movable_value: null,
				valuable_value: null,
				year: null,
				inhabitants: null,
				wall_type: null,
				roof_type: null,
				is_public_space: null,
				is_permanently_inhabited: null,
				mortgage: null,
				under_construction: null,
			});
			commit('setOutbuildings', []);
			commit('setBuildings', []);
			commit('setPremises', []);
			commit('setMovables', []);
			commit('setValuables', []);
		},
		sendMessage: async ({}, message) => {
			try {
				const response = await window.axios.post(`/api/messaging/user-message`, message);

				return response.data;
			} catch (error) {
				return error.response.data;
			}
		},
		sendCompanyMessage: async ({ getters }, message) => {
			try {
				const response = await window.axios.post(`/api/messaging/company-message`, {
					...message,
					category: getters.getCategory,
				});

				return response.data;
			} catch (error) {
				return error.response.data;
			}
		},
		fetchClientRealEstates: async ({ commit }, clientId) => {
			const response = await window.axios.get(`/api/calculator/real-estate/${clientId}`);

			commit('setRealEstates', response.data.real_estates);
		},
		updateUserId: async ({ getters }) => {
			if (getters['getCalculation'].user_id === null) {
				const response = await window.axios.put(
					`/api/calculator/calculation/hash/${getters['getCalculation'].hash}/user_id`,
					{
						user_id: getters['auth/getCurrentUser'].id,
					},
				);

				return response.data;
			}
		},
		saveStartOfRisk: async ({ getters }) => {
			const response = await window.axios.put(
				`/api/calculator/calculation/hash/${getters['getCalculation'].hash}/start_of_risk`,
				{
					start_of_risk: getters['getCalculation'].start_of_risk,
				},
			);
		},
        saveSelectedOffer: async ({ },{ hash, insurerUuid}) => {
            const response = await window.axios.put(
                `/api/calculator/calculation/hash/${hash}/selected_insurer_uuid`,
                {
                    insurer_uuid: insurerUuid,
                },
            );
        },
        fetchClientBikaRealEstates: async ({ commit }, bikaId) => {
            const response = await window.axios.get(`/vue/bika-real-estate`,{
                params:{
                    bika_id: bikaId,
                }
            });
            if(response.data.success) {
                commit('setBikaRealEstate', response.data.data);
            }
        },
        fetchMatchingRealEstateUsers: async ({ commit, getters }) => {
            const response = await window.axios.post('/api/calculator/find-matching-realestate',{
                real_estate: getters['getRealEstate'],
                user_id: getters['auth/getCurrentUser'].id,
                hasParcelNumber: getters['getHasParcelNumber'],
            });

            commit('setMatchingRealEstateUsers', response.data);
        },
        setNeedsHelp: async ({ commit, getters }) => {
            const response = await window.axios.post(`/api/calculator/calculation/hash/${getters['getCalculation'].hash}/markWithNeedsHelp`);
            if(response.data.success) {
                return true;
            }
        },

	};
}
